var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 5.59961H12.6C12.9713 5.59961 13.3274 5.74711 13.5899 6.00966C13.8525 6.27221 14 6.62831 14 6.99961C14 7.37091 13.8525 7.72701 13.5899 7.98956C13.3274 8.25211 12.9713 8.39961 12.6 8.39961H1.4C1.0287 8.39961 0.672601 8.25211 0.410051 7.98956C0.1475 7.72701 0 7.37091 0 6.99961C0 6.62831 0.1475 6.27221 0.410051 6.00966C0.672601 5.74711 1.0287 5.59961 1.4 5.59961Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 1.4V12.6C8.40039 12.9713 8.25289 13.3274 7.99034 13.5899C7.72779 13.8525 7.37169 14 7.00039 14C6.62909 14 6.27299 13.8525 6.01044 13.5899C5.74789 13.3274 5.60039 12.9713 5.60039 12.6L5.60039 1.4C5.60039 1.0287 5.74789 0.672601 6.01044 0.410051C6.27299 0.1475 6.62909 0 7.00039 0C7.37169 0 7.72779 0.1475 7.99034 0.410051C8.25289 0.672601 8.40039 1.0287 8.40039 1.4Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.40b3d009.svg";
export { ForwardRef as ReactComponent };